import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { toggleThumbView, movePageIndex } from '../actions'

import _ from 'lodash'
import className from 'classnames'

import Thumbnail from '../components/thumbnail'
import Slider from 'react-slick'

import './footer.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'



class Footer extends Component {

    constructor(props) {
    super(props)
    this.changeHandler = this.changeHandler.bind(this)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    }

    getThumbnails(isZero) {
        let items = this.props.thumbnails;
        // if (isZero < 0) {
        //     items = _.filter(this.props.thumbnails, (thumb) => {
        //         return thumb.pageIndex < this.props.currentIndex
        //     })
        // } else if (isZero > 0) {
        //     items = _.filter(this.props.thumbnails, (thumb) => {
        //         return thumb.pageIndex > this.props.currentIndex
        //     })
        // } else {
        //     items = _.filter(this.props.thumbnails, (thumb) => {
        //         return thumb.pageIndex === this.props.currentIndex
        //     })
        // }

        return _.map(items, (thumb) =>
                     <div key = {thumb.pageIndex} ><img className='thumbImage' src= {thumb.imageUrl} ></img></div>
                    )
    }

    changeHandler(i) {
      if (i < 0 ) return;
      if (i > this.props.totalPage ) return;

      this.props.movePageIndex(i);
    }

    next() {
      if (this.refs.slider !== undefined) {
        if (this.props.currentIndex >= 0 
          && this.props.currentIndex < this.props.totalPage-1 
          && this.refs.slider.props.initialSlide < this.props.totalPage -1) {
          this.refs.slider.slickNext()
        }
      }
    }

    previous() {
      if (this.refs.slider !== undefined) {
        if (this.props.currentIndex > 0 
          && this.props.currentIndex < this.props.totalPage 
          && this.refs.slider.props.initialSlide < this.props.totalPage ) {
          this.refs.slider.slickPrev()
        }
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.refs.slider !== undefined) {
         if (prevProps.currentIndex !== this.props.currentIndex) {
           this.refs.slider.slickGoTo(this.props.currentIndex)
         }
      }
    }

    renderThumb() {
        if (this.props.showThumbView) {

            let slideCnt = 5 ;(this.props.totalPage >= 5 ? 5 : this.props.totalPage)

            if (this.props.totalPage >= 5 ) {
              slideCnt = 5
            } else if (this.props.totalPage >=3) {
              slideCnt = 3
            } else {
              slideCnt = this.props.totalPage
            }

            let settings = {
              arrows : false,
              className: 'center',
              centerMode: true,
              infinite: false,
              speed: 500,
              centerPadding: '0px',
              slidesToShow: slideCnt,
              slidesToScroll: 1,
              focusOnSelect:true,
              initialSlide: this.props.currentIndex,
              afterChange:this.changeHandler,
            };
            return (              
              <div className="FooterBG">
              <div className="FooterContent">
              <Slider ref='slider' {...settings} >
                {this.getThumbnails(0)}
              </Slider>
              <button  key='0' type='button' className="sliderArrow prevArrow" onClick={this.previous} ></button>
              <button  key='1' type='button' className="sliderArrow nextArrow" onClick={this.next}></button>
              </div>
              </div>)
        }
    }

    render() {
        let show = this.props.showThumbView ? "Down" : "Up"
        return (
            <div className="Footer no-print">
              <div className="SemiCircle" onClick={this.props.toggleThumbView}>
                <img src={require("../image/navi_next_ico.png")} className={className('CenterImage', show)} alt={show} />
              </div>
              { this.renderThumb() }
            </div>
        )
    }
}

Footer.propTypes = {
    showThumbView: PropTypes.bool.isRequired,

    thumbnails: PropTypes.array,
    currentIndex: PropTypes.number,
    totalPage : PropTypes.number,

    toggleThumbView: PropTypes.func,
    movePageIndex: PropTypes.func,
}

function mapStateToProps(state) {
    const { extra, viewer } = state
    let thumb = viewer.thumbnail === undefined || viewer.thumbnail.items.cd !== '0000' ? [] : viewer.thumbnail.items.data.thumbItems
    let totalPage = viewer.openStatus.pageInfo === undefined || viewer.openStatus.pageInfo.cd !== '0000' ? 0 : viewer.openStatus.pageInfo.data.pageCount
    return {
        showThumbView: extra.showThumbView,
        thumbnails: thumb,
        currentIndex: viewer.index,
        totalPage : totalPage

    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleThumbView: () => dispatch(toggleThumbView()),
        movePageIndex: (index) => dispatch(movePageIndex(index)),
    }
}

export default connect (mapStateToProps, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/containers/footer.js